<template>
  <el-upload
    ref="uploader"
    :data="uploadData"
    :before-upload="handleBeforeUpload"
    :on-success="handleSuccess"
    v-on="$listeners"
    v-bind="$attrs"
  >
    <template #trigger>
      <slot name="trigger" />
    </template>
    <template v-slot:tip>
      <slot name="tip" />
    </template>
    <slot />
  </el-upload>
</template>

<script>
import SparkMD5 from 'spark-md5'
import { STATUS_CODE } from '@/utils/constants'
import emitter from 'element-ui/src/mixins/emitter'

export default {
  name: 'VerifyUploader',
  mixins: [emitter],
  props: {
    beforeUpload: Function,
    onError: Function,
    onSuccess: Function,
    data: Object
  },
  data() {
    return {
      uploadData: {
        ...this.$props.data,
        md5: ''
      }
    }
  },
  watch: {
    '$props.data'(newVal) {
      this.uploadData = {
        ...newVal,
        md5: this.uploadData.md5
      }
    }
  },
  created() {
    // 因为watch配置的key只支持点路径，所以访问连字符属性的时候得使用$watch方法的表达式监听
    this.$watch(function() {
      return this.$attrs['file-list']
    }, function(newVal) {
      this.dispatch('ElFormItem', 'el.form.change', newVal)
    }, {
      deep: true
    })
  },
  methods: {
    handleBeforeUpload(file) {
      return this.calMediaMD5(file).then(md5 => {
        if (this.beforeUpload) {
          file.md5 = md5
          return this.beforeUpload(file)
        }

        return Promise.resolve()
      }).catch(error => {
        // console.error(error)
        return Promise.reject(error)
      })
    },

    handleSuccess(resp, file, fileList) {
      const { onSuccess, onError } = this.$props
      if ('code' in resp && resp.code === STATUS_CODE.SUCCESS) {
        if (onSuccess && typeof onSuccess === 'function') {
          onSuccess(resp, file, fileList)
        }
      } else {
        onError(new Error(resp.msg), file)
      }
    },

    calMediaMD5(file) {
      const blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice
      const chunkSize = 2097152 // Read in chunks of 2MB
      const chunks = Math.ceil(file.size / chunkSize)
      const spark = new SparkMD5.ArrayBuffer()
      const fileReader = new FileReader()
      let currentChunk = 0

      function loadNext() {
        var start = currentChunk * chunkSize
        var end = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize

        // 分块读取, 避免大文件内存溢出
        fileReader.readAsArrayBuffer(blobSlice.call(file, start, end))
      }

      loadNext()

      return new Promise((resolve, reject) => {
        fileReader.onload = (e) => {
        // console.log('read chunk nr', currentChunk + 1, 'of', chunks)
          spark.append(e.target.result) // Append array buffer
          currentChunk++

          if (currentChunk < chunks) {
            loadNext()
          } else {
            const md5 = spark.end()
            console.log('finished loading')
            console.info('computed hash', md5) // Compute hash
            this.uploadData.md5 = md5 // '12a3' // md5
            resolve(md5)
          }
        }

        fileReader.onerror = () => {
          console.warn('oops, something went wrong.')
          this.$message({
            type: 'error',
            message: '音频计算MD5异常'
          })
          reject()
        }
      })
    },
  }
}
</script>
